import { App } from "vue";
import { default as Book } from "./Book/index.vue";
import AudioComp from "./AudioComp/index.vue";
import ImagePreview from "./ImagePreview/index.vue";
import Loading from "./Loading/index.vue";
import Preview from "./Preview/index.vue";
import Phone from "./Phone/index.vue";
import Popup from "./Popup/index.vue";
import FilePreview from "./Preview/components/FilePreview/index.vue";
import SettingModal from "./SettingModal/index.vue";
import VipTip from "./Preview/components/FilePreview/components/VipTip/index.vue";

export * from "./Book/index";
export * from "./SettingModal/index";
export * from "./Preview/index";

export {
  Book,
  AudioComp,
  ImagePreview,
  Loading,
  Preview,
  Phone,
  Popup,
  FilePreview,
  SettingModal,
  VipTip,
};

const loadedScripts = new Set<string>();

function loadScript(src: string): Promise<void> {
  return new Promise((resolve, reject) => {
    if (loadedScripts.has(src)) {
      resolve();
      return;
    }
    const script = document.createElement("script");
    script.src = src;
    script.onload = () => {
      loadedScripts.add(src);
      resolve();
    };
    script.onerror = reject;
    document.head.appendChild(script);
  });
}

export const commonComponentsInstall = {
  install(_app: App, options?: { scripts?: string[] }) {
    const scripts = options?.scripts || [
      "https://static.mazhou.cc/mazhou/jquery.js",
      "https://static.mazhou.cc/mazhou/turn.min.js",
      "https://static.mazhou.cc/mazhou/base64.min.js",
    ];
    Promise.all(scripts.map(loadScript)).catch((err) => {
      console.error("Failed to load external scripts:", err);
    });
  },
};
